/**
 * Time 类型
 * Time("22:33:54")
 */

import Declaration, { DeclarationFactory } from './base';



// 判断是否为正确的日期格式
export function isAcceptableTime(v: string) {
  return /^(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])$/.test(v);
}

class TimeDeclaration extends Declaration implements DeclarationFactory {

  public declaration = 'Time';


  public generateRegExp() {
    return /(^Time\(\"(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])\"\))|(^Time\(\'(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])\'\))/;
  }

  public match(input: string) {
    const matched = input.match(/^(Time\(([^)]*)\))/);

    if (matched) {
      const timeString = matched[2].slice(1, matched[2].length - 1);
      if (isAcceptableTime(timeString)) {
        return {
          type: 'Time',
          raw: matched[1],
          declaration: this.declaration,
          value: timeString,
          isAtom: true,
          isDeclaration: true
        };
      } else {
        throw this.generateInvalidError(matched[1], matched[2], 'Argument formater of `Time` must be `Time("14:10:15")`');
      }
    }
  }
}


export default new TimeDeclaration();
